import { createApi } from "@reduxjs/toolkit/query/react";
import { encryptQueryString, transformRequest } from '../../../utils/API/requestMiddleware';
import { defautBaseQuery } from '../../../utils/API/fetchBaseQuery';
import { transformErrorResponse, transformSucessResponse } from "../../../utils/API/responseMiddleware";

const corporateMembershipTaskListApi = createApi({
    reducerPath: 'corporateMembershipTaskListApi',
    baseQuery: defautBaseQuery,
    endpoints: (builder) => ({
        getCorporateMemberDetailsByCorporateMemberId: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/Membership/GetCorporateMemberDetailsByCorporateMemberId?id=${parseInt(id)}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        lockCorporateApplicationByAdmin: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/Membership/LockCorporateApplicationByAdmin`),
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        updateCompanyDetailAndOtherInformation: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/Membership/UpdateCompanyDetailAndOtherInformation`),
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getMembershipSubscriptionDetailById: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/Membership/GetMembershipSubscriptionDetailById?id=${parseInt(id)}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getGstRate: builder.query({
            query: (details) => ({
                url: "/Common/GetGSTRate",
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getCorporateMembershipPricing: builder.query({
            query: () => ({
                url: encryptQueryString('/Membership/GetCorporateMembershipPricing'),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        updateCorporateMembershipSubscriptionByAdmin: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/Membership/UpdateCorporateMembershipSubscriptionByAdmin`),
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        rejectCorporateMemberApplication: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/Membership/RejectCorporateMemberApplication`),
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getMemberhipPricingDetailsById: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/Membership/GetMemberhipPricingDetailsById`),
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        corporateMembershipCommitteeApprovalList: builder.query({
            query: ({ id, id2 }) => ({
                url: encryptQueryString(`/Membership/CorporateMembershipCommitteeApprovalList?id=${id}&id2=${id2}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        corporateApplicationReadyForApproval: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/Membership/CorporateApplicationReadyForApproval`),
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        readyForApprovalDetailsByCorporateMemberId: builder.query({
            query: ({ id, id2 }) => ({
                url: encryptQueryString(`/Membership/ReadyForApprovalDetailsByCorporateMemberId?id=${id}&id2=${id2}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        boardApprovalAssignmentList: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/BoardMemberManagement/BoardApprovalAssignmentList`),
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        saveCorporateMemberClarificationDetails: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/Membership/SaveCorporateMemberClarificationDetails`),
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        saveCorporateMemberClarificationDetailsAfterApproval: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/Membership/SaveCorporateMemberClarificationDetailsAfterApproval`),
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        assignCorporateApplicationToBoard: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/BoardMemberManagement/AssignCorporateApplicationToBoard`),
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        corporateBoardApprovalUpdate: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/BoardMemberManagement/CorporateBoardApprovalUpdate`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        generateQuotation: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/Membership/GenerateQuotation`),
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        approveCorporateApplication: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/Membership/ApproveCorporateApplication`),
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        createInvoice: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/Xero/CreateInvoice`),
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getSubsidiaryCompanyInfoByMemberId: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/Membership/GetSubsidiaryCompanyInfoByMemberId?id=${parseInt(id)}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getCorporateMemberDetailsbyTasklistId: builder.query({
            query: ({ id, id2 }) => ({
                url: encryptQueryString(`/Membership/GetCorporateMemberDetailsbyTasklistId?id=${id}&id2=${id2}`
                ),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        discontinueCorporateApplication: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/Dashboard/DiscontinueCorporateApplication`),
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getCorporateMemberDetailsInAdminByTaskListId: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/Membership/GetCorporateMemberDetailsInAdminByTaskListId?id=${parseInt(id)}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getMembershipSubscriptionForCorporateMemberDetailById: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/Membership/GetMembershipSubscriptionForCorporateMemberDetailById?id=${parseInt(id)}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        corporateApplicationRejectByBordApproval: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/Membership/CorporateApplicationRejectByBordApproval`),
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getClarificationAuditLogListById: builder.query({
            query: ({ id, id2 }) => ({
                url: encryptQueryString(`/Membership/GetClarificationAuditLogListById?id=${id}&id2=${id2}`
                ),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),

})

export const {
    useLazyGetCorporateMemberDetailsByCorporateMemberIdQuery,
    useLockCorporateApplicationByAdminMutation,
    useUpdateCompanyDetailAndOtherInformationMutation,
    useLazyGetMembershipSubscriptionDetailByIdQuery,
    useLazyGetGstRateQuery,
    useLazyGetCorporateMembershipPricingQuery,
    useUpdateCorporateMembershipSubscriptionByAdminMutation,
    useRejectCorporateMemberApplicationMutation,
    useGetMemberhipPricingDetailsByIdMutation,
    useLazyCorporateMembershipCommitteeApprovalListQuery,
    useCorporateApplicationReadyForApprovalMutation,
    useBoardApprovalAssignmentListMutation,
    useLazyReadyForApprovalDetailsByCorporateMemberIdQuery,
    useSaveCorporateMemberClarificationDetailsMutation,
    useAssignCorporateApplicationToBoardMutation,
    useLazyCorporateBoardApprovalUpdateQuery,
    useGenerateQuotationMutation,
    useApproveCorporateApplicationMutation,
    useLazyGetSubsidiaryCompanyInfoByMemberIdQuery,
    useCreateInvoiceMutation,
    useLazyGetCorporateMemberDetailsbyTasklistIdQuery,
    useDiscontinueCorporateApplicationMutation,
    useLazyGetCorporateMemberDetailsInAdminByTaskListIdQuery,
    useLazyGetMembershipSubscriptionForCorporateMemberDetailByIdQuery,
    useSaveCorporateMemberClarificationDetailsAfterApprovalMutation,
    useCorporateApplicationRejectByBordApprovalMutation,
    useLazyGetClarificationAuditLogListByIdQuery
} = corporateMembershipTaskListApi;

export default corporateMembershipTaskListApi;

